<template>
  <div id="full">
    <div class="panel">
      <div class="panel-header">
        <div class="header-left">
          <img src="@/assets/couch.png" alt="Logo" class="couch-logo">
          <strong>Lobby Terminal</strong>
        </div>
        <!-- Tier Toggle -->
        <div class="mode-toggle">
          <span class="forms-label" :data-active="!modeCheckIn">Forms</span>
          <label class="switch">
            <input type="checkbox" id="mode-toggle" v-model="modeCheckIn" />
            <span class="slider"></span>
          </label>
          <span class="check-in-label" :data-active="modeCheckIn">Check-in</span>
        </div>
      </div>
      <transition name="appear" mode="out-in">
        <div class="panel-body" v-if="!modeCheckIn">
          <h2>Open Patient Forms</h2>
          <div class="forms-bar">
            <input class="form-control search" v-model="query" placeholder="Search forms..." />
            <select class="form-control" name="preset" id="preset" @change="handleSelectPacket">
              <option value="">Select a packet</option>
              <option :value="preset.id" v-for="preset of presets" :key="preset.id">{{ preset.name }}</option>
            </select>
          </div>
          <div class="form-list">
            <div class="form-list-item" v-for="form of getFormsToShow()" :key="form.id"
              @click.prevent="toggleFormSelected(form.id)">
              <div class="checkbox" :data-checked="isFormSelected(form.id)"></div>
              <span class="form-name">{{ form.name }}</span>
            </div>
          </div>
          <div class="form-actions">
            <p v-if="selectedForms.size == 0">Select one or more forms</p>
            <a v-else class="button primary" :href="getURLForForms()" target="_blank">Open {{ selectedForms.size }}
              Forms</a>
          </div>
        </div>
        <div class="panel-body check-in-panel-body" v-else>
          <div class="check-in-container">
            <div class="check-in-header">
              <h2>Appointment Check In</h2>
              <p>Welcome! Please sign in to confirm the information we have on-file about you. We may also require you
                to
                complete some forms.</p>
            </div>
            <form class="check-in-form" @submit.prevent="attemptLookupAndRedirect">
              <div class="form-group">
                <label for="name" class="form-label">Patient Last Name</label>
                <input type="text" class="form-control" id="name" name="name" v-model="lastName" placeholder="Last Name"
                  autocomplete="off" data-lpignore="true" data-form-type="other" required />
              </div>
              <div class="form-group">
                <label for="dateOfBirth" class="form-label">Patient Date of Birth</label>
                <input id="dateOfBirth" type="text" name="dateOfBirth" class="form-control" v-model="dateOfBirth"
                  placeholder="mm/dd/yyyy" autocomplete="off" data-lpignore="true" data-form-type="other"
                  @input="formatDateOfBirth" required />
              </div>
              <div class="form-footer">
                <button class="button primary" @click.prevent="attemptLookupAndRedirect">
                  <img v-if="isPending" src="/loading.svg" alt="Loading" class="loading">
                  <span v-else>Continue</span>
                </button>
                <p class="error">{{ errorText }}</p>
              </div>
            </form>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { fetchFormsForAccount, fetchPresetsForAccount, getCheckInUrl } from "@/api";

export default {
  name: "PublicPortalView",
  data() {
    return {
      query: "",
      modeCheckIn: false,
      forms: [],
      presets: [],
      isLoading: false,
      selectedForms: new Set(),
      isPending: false,
      lastName: "",
      dateOfBirth: "",
      errorText: ""
    };
  },
  created() {
    this.fetchOfficeData();
  },
  methods: {
    async fetchOfficeData() {
      const nameUnique = this.$route.params.uniqueName;

      try {
        this.isLoading = true;

        const [formsRes, presetsRes] = await Promise.all([
          fetchFormsForAccount(nameUnique),
          fetchPresetsForAccount(nameUnique)
        ]);

        this.forms = formsRes;
        this.presets = presetsRes;
      } catch (err) {
        console.error(err);
      } finally {
        this.isLoading = false;
      }
    },
    async attemptLookupAndRedirect() {
      if (this.isPending) {
        return;
      }

      const uniqueName = this.$route.params.uniqueName;
      try {
        this.isPending = true;
        const privateUrl = await getCheckInUrl(uniqueName, this.lastName, this.dateOfBirth);
        this.$router.push(`/submission/${privateUrl}?checkin=1`);
      } catch (err) {
        this.errorText = err.message || 'An unexpected error occurred. Please try again.';
      } finally {
        this.isPending = false;
      }
    },
    formatDateOfBirth() {
      let numbers = this.dateOfBirth.replace(/\D/g, ""); // Remove non-numeric characters
      if (numbers.length > 4) {
        numbers =
          numbers.substring(0, 2) +
          "/" +
          numbers.substring(2, 4) +
          "/" +
          numbers.substring(4, 8);
      } else if (numbers.length > 2) {
        numbers = numbers.substring(0, 2) + "/" + numbers.substring(2, 4);
      }
      this.dateOfBirth = numbers.substring(0, 10); // Ensure it doesn't exceed the length for mm/dd/yyyy
    },
    isFormSelected(id) {
      return this.selectedForms.has(id);
    },
    toggleFormSelected(id) {
      if (this.selectedForms.has(id)) {
        this.selectedForms.delete(id);
      } else {
        this.selectedForms.add(id);
      }
    },
    getFormsToShow() {
      const q = this.query.toLowerCase().trim();
      if (!q) return this.forms;
      return this.forms.filter((form) => form.name.toLowerCase().includes(q));
    },
    handleSelectPacket(event) {
      const id = event.target.value;
      if (id == '') {
        this.selectedForms.clear();
        return;
      }

      const preset = this.presets.find(p => p.id == id);
      if (!preset) return;
      this.selectedForms = new Set([...preset.forms])
      console.log(this.selectedForms);
    },
    getURLForForms() {
      const forms = this.forms.filter(f => this.selectedForms.has(f.id));
      const str = forms.map(f => f.id).join(',');
      const uniqueName = this.$route.params.uniqueName;
      return `/${uniqueName}/[${str}]`;
    }
  },
};
</script>

<style scoped>
#full {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.panel {
  width: 100%;
  height: 100%;
  background: #fff;
  box-shadow: 0px 0px 8px #00000011;
  display: flex;
  flex-direction: column;
}

.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 30px;
  box-shadow: 0px 4px 8px #00000011;
  position: relative;
}

.panel-body {
  padding: 30px;
  height: 1px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.panel-body[v-else] {
  display: flex;
  align-items: center;
  justify-content: center;
}

.form-list {
  display: flex;
  flex-direction: column;
  height: 1px;
  flex: 1;
  overflow-y: auto;
}

.form-list-item {
  padding: 15px;
  display: flex;
  align-items: center;
  gap: 15px;
}

.form-list-item:not(:first-child) {
  border-top: 1px solid #eee;
}

.form-list-item:hover {
  background: #f5f5f5;
  cursor: pointer;
}

/* Base styling for the checkbox */
.checkbox {
  width: 24px;
  height: 24px;
  border: 2px solid #ccc;
  border-radius: 4px;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  flex-shrink: 0;
}

/* Styling when data-checked is true */
.checkbox[data-checked="true"] {
  background-color: var(--color-primary);
  border-color: var(--color-primary);
}

/* Creating the checkmark using the ::after pseudo-element */
.checkbox[data-checked="true"]::after {
  content: "";
  position: absolute;
  left: 7px;
  top: 3px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

/* Mode toggle */
.mode-toggle {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: fit-content;
  gap: 15px;
}

.mode-toggle span {
  font-weight: 600;
  color: #666;
  transition: color 0.3s ease;
}

.mode-toggle [data-active="true"] {
  color: var(--color-primary);
}

.switch {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 24px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--color-primary);
  transition: 0.4s;
  border-radius: 34px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked+.slider {
  background-color: var(--color-primary);
}

input:checked+.slider:before {
  transform: translateX(24px);
}

.forms-bar {
  padding: 20px 0px;
  display: flex;
  gap: 15px;
}

.form-actions {
  margin-top: 50px;
  display: flex;
  justify-content: flex-end;
  padding-bottom: 50px;
}

.form-actions .button {
  width: auto;
  padding: 15px 30px;
}

.form-control {
  background: #FAFAFA;
  border-bottom: 1px solid #CCC;
  border-radius: 5px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 15px;
}

.couch-logo {
  width: 30px;
  height: 30px;
}

.check-in-container {
  display: flex;
  flex-direction: column;
  gap: 30px;
  max-width: 500px;
  width: 100%;
  padding: 50px;
  background: #FFF;
  border-radius: 10px;
  box-shadow: 0px -15px 30px -15px #00000022;
}

.check-in-header h2 {
  margin-bottom: 15px;
  color: #333;
}

.check-in-header p {
  color: #666;
  line-height: 1.5;
}

.check-in-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-label {
  font-weight: 500;
  color: #333;
}

.error {
  color: #dc3545;
  margin-top: 10px;
  text-align: center;
}

.form-control {
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
}

.form-control:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 2px rgba(var(--color-primary-rgb), 0.1);
}

.form-group {
  margin-top: 20px;
}

.check-in-panel-body {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  background: linear-gradient(to bottom, #e1e6ea 30%, #FFF 60%);
}

@media screen and (max-width: 500px) {
  .panel-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .check-in-panel-body {
    justify-content: flex-start;
    padding: 0;
  }

  .check-in-container {
    padding: 30px;
    box-shadow: none;
    border-radius: 0;
  }
}

.form-footer {
  margin-top: 30px;
}
</style>